/**
 * Gmail-herstel (24 oktober 2026): welke bronnen een antwoord als VERLOPEN noemt. PUUR.
 *
 * De backend schrijft bij een sleutel die Google niet meer erkent een vaste zin
 * (`VERLOPEN_ZIN` in backend/services/google_oauth.py). Dit bestand herkent die zin, en de
 * bubbel zet er de knop Opnieuw koppelen onder, die Instellingen op Verbindingen opent.
 * Er staat aan beide kanten een wachter die eist dat de zin gelijk blijft.
 */

// Moet gelijk blijven aan `VERLOPEN_ZIN` in backend/services/google_oauth.py.
export const VERLOPEN_ZIN =
  "De toegang tot {naam} is verlopen of ingetrokken bij Google. " +
  "Koppel {naam} opnieuw in Instellingen > Verbindingen.";

const ontsnap = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const PATROON = new RegExp(
  ontsnap(VERLOPEN_ZIN).replace(/\\\{naam\\\}/, "(.+?)").replace(/\\\{naam\\\}/, "\\1"), "g");

/** De bronnamen waarvoor het antwoord de verlopen-zin draagt, elk een keer. */
export function verlopenBronnen(tekst) {
  const namen = [];
  for (const m of (tekst || "").matchAll(PATROON)) {
    if (!namen.includes(m[1])) namen.push(m[1]);
  }
  return namen;
}

/** Het adres dat Instellingen op Verbindingen opent (zie `lib/instellingenadres.js`). */
export const HERKOPPEL_ADRES = "?instellingen=connections";

/**
 * GL201-2 (glasronde 0.9.201): de bronnen die het antwoord van GET /connections als verlopen
 * meldt, elk een keer, alleen bij een koppeling die nog hangt. PUUR.
 */
export function verlopenNamen(antwoord) {
  const namen = [];
  const bronnen = antwoord?.bronnen || [];
  for (const k of antwoord?.koppelingen || []) {
    if (!k?.actief || !k?.verlopen) continue;
    const naam = k.naam || bronnen.find((b) => b.sleutel === k.bron)?.naam || k.bron;
    if (naam && !namen.includes(naam)) namen.push(naam);
  }
  return namen;
}
